// @flow
import * as React from 'react';
import { graphql } from 'react-apollo';
import memoize from 'memoizee';

import SEARCH_FOR_FAMILY_QUERY from '../queries/SearchForFamilyQuery.gql';

import type {
  SearchForFamilyMembers,
  SearchForFamilyMembers_potentialFamily,
} from '../queries/__generated__/SearchForFamilyMembers';

const DATA_RELOAD_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes, for memoize

type Props = {
  children: (props: {
    loading: boolean,
    familyMembers: $ReadOnlyArray<SearchForFamilyMembers_potentialFamily>,
  }) => React.Node,
  query: string,
  relation: 'parent' | 'child',
  data: ReactApolloData<SearchForFamilyMembers>,
  isMinQueryLength: boolean,
};

class FamilyTypeaheadContainer extends React.Component<Props, void> {
  componentDidUpdate(prevProps: Props) {
    if (prevProps.query !== this.props.query && this.props.isMinQueryLength) {
      this.loadQuery(this.props.query);
    }
  }

  loadQuery = memoize(
    query => {
      this.props.data.refetch({ query });
    },
    { maxAge: DATA_RELOAD_TIMEOUT_MS }
  );

  isLoading = (props: Props): boolean => {
    return props.data.loading || props.data.networkStatus < 7;
  };

  getFamilyMembers = (props: Props) => {
    return props.data.potentialFamily || [];
  };

  render() {
    return this.props.children({
      loading: this.isLoading(this.props),
      familyMembers: this.getFamilyMembers(this.props),
    });
  }
}

const withFamilyResults = graphql(SEARCH_FOR_FAMILY_QUERY, {
  options: ({ relation, query }) => ({
    variables: {
      relation,
      query,
    },
  }),
});

export { FamilyTypeaheadContainer };

export default withFamilyResults(FamilyTypeaheadContainer);
